import { supabase } from '@/lib/supabase';
import type { VitalSigns } from '@/types/db';

interface UpdateMed {
  drug_name: string | null;
  dosage: string | null;
  frequency: string | null;
  duration_days: number | null;
}

export interface UpdateEventInput {
  profileId: string;
  eventId: string;
  title: string | null;
  eventDate: string | null;
  doctorName: string | null;
  doctorSpecialty: string | null;
  clinicName: string | null;
  clinicAddress: string | null;
  clinicPhone: string | null;
  insuranceCompany: string | null;
  insuranceClaim: string | null;
  diagnosis: string | null;
  notes: string | null;
  vitalSigns?: VitalSigns;
  medications: UpdateMed[];
}

export async function updateEvent(input: UpdateEventInput): Promise<void> {
  const { error } = await supabase.rpc('update_event', {
    p_profile_id: input.profileId,
    p_event_id: input.eventId,
    p_event: {
      title: input.title,
      event_date: input.eventDate,
      doctor_name: input.doctorName,
      doctor_specialty: input.doctorSpecialty,
      clinic_name: input.clinicName,
      clinic_address: input.clinicAddress,
      clinic_phone: input.clinicPhone,
      insurance: {
        ...(input.insuranceCompany ? { company: input.insuranceCompany } : {}),
        ...(input.insuranceClaim ? { claim_number: input.insuranceClaim } : {}),
      },
      diagnosis: input.diagnosis,
      notes: input.notes,
      ...(input.vitalSigns ? { vital_signs: input.vitalSigns } : {}),
    },
    p_medications: input.medications,
  });
  if (error) throw error;
}
